<ng-container *transloco="let convert;">
  <div [id]="'inventory_question_overview_' + identifier" class="question-container__body d-flex flex-column">
    <div class="question-container__body-section question-container__body-section--top">
      <div class="d-flex flex-column-reverse flex-sm-row justify-content-between">
        <p class="sell-question__question mb-2" [class.mb-3.mb-md-2]="showReplyBtn">
          @if (showUserName) {
            <span class="askedBy"><strong>{{ askedBy != null ? askedBy + ': ' : '' }}</strong></span>
          }
          <span
            [id]="'inventory_question_' + identifier"
            class="fst-italic questionBlock__content"
            [ngClass]="{ withdrawnQuestion: withdrawnQuestion }"
            >{{ question.question }}</span
            >
            @if (withdrawnQuestion) {
              <span class="ms-2 questionBlock__indicator">(Withdrawn)</span>
            }
          </p>
          <div class="question-container__meta-date">
            @if (question.answeredDate) {
              <span [id]="'inventory_question_answer_date_time_' + identifier">{{ answerDate }}</span>
            } @else {
              <span [id]="'inventory_question_ask_date_time_' + identifier">{{ askedDate }}</span>
            }
          </div>
        </div>
      </div>

      <div class="question-container__body-section--bottom d-flex flex-column flex-sm-row justify-content-between">
        @if (status === 'answered' && question.answer && !withdrawnQuestion) {
          <div
            class="d-flex align-items-center mt-2 sell-question__container"
            >
            <p class="sell-question__answer m-0">
              <span class="label d-none d-md-inline-block">{{convert('sellModule.question.questionBlock.textReply')}}</span>
              <span [id]="'inventory_answer_' + identifier" class="sell-question__answer-text">{{
                question.answer
              }}</span>
            </p>
          </div>
        }

        @if (!isAdmin && !isQuestionActionable && status === 'unanswered') {
          <span class="actionable-message">
            {{convert('sellModule.question.questionBlock.textContactSalesManager')}}
          </span>
        }

        @if (status === 'unanswered' && vehicleStatus === 'ACTIVE' && isQuestionActionable) {
          <button
            (click)="toggle($event)"
            [attr.aria-expanded]="open"
            data-track-elem="accordion"
            [attr.data-track-name]="open ? 'Close' : 'Reply'"
            data-track-trigger="statechange"
            [attr.data-track-state]="open ? 'opened' : 'closed'"
            class="btn btn-outline-primary reply-btn toggle-btn"
            type="button"
            [attr.aria-label]="open ? convert('sellModule.question.questionBlock.ariaLabelCloseDrawer') : convert('sellModule.question.questionBlock.ariaLabelReply')"
            >
            {{ open ? convert('sellModule.question.questionBlock.textClose') : convert('sellModule.question.questionBlock.ariaLabelReply') }}
          </button>
        }

        @if (status === 'unanswered' && !isQuestionActionable && !open) {
          <button
            data-track-elem="button"
            data-track-name="View Conversation"
            (click)="toggle($event)"
            class="btn btn-link view-all toggle-btn d-none d-md-inline-block"
            [attr.aria-label]="convert('sellModule.question.questionBlock.ariaLabelViewConversation')"
            >
            {{convert('sellModule.question.questionBlock.ariaLabelViewConversation')}}
          </button>
        }

        @if (status === 'answered' && !open) {
          <button
            data-track-elem="button"
            data-track-name="View Conversation"
            (click)="toggle($event)"
            class="btn btn-link view-all toggle-btn d-none d-md-inline-block ms-auto"
            [attr.aria-label]="convert('sellModule.question.questionBlock.ariaLabelViewConversation')"
            >
            {{convert('sellModule.question.questionBlock.ariaLabelViewConversation')}}
          </button>
        }
      </div>
      @if (status === 'answered' && !open) {
        <button
          data-track-elem="button"
          data-track-name="View Conversation"
          (click)="toggle($event)"
          class="btn btn-link view-all toggle-btn d-md-none"
          [attr.aria-label]="convert('sellModule.question.questionBlock.ariaLabelViewConversation')"
          >
          {{convert('sellModule.question.questionBlock.ariaLabelViewConversation')}}
        </button>
      }
    </div>
  </ng-container>
